import React,{useState, useEffect} from 'react';
import Grid from '@material-ui/core/Grid';
import LockIcon from '@material-ui/icons/Lock';
import FavoriteIcon from '@material-ui/icons/Favorite';
import Modal from '@material-ui/core/Modal';
//import Button from '@material-ui/core/Button';
import {Tools} from './Tools';
import {Styles} from './Styles';
import {Inc,Girl} from './Inc';
import Confirm from './Confirm';
import First from './First';
import Happy from './Happy';
import Success from './Success';
import Result from './Result';
import Ajax from './Ajax';
import Loading from './Loading';

interface Props {
    userId:string,
    move(str:string):void,
    save(id:string):void,
}

let isLoading = true;
let isWaiting = false;
let unlockedIndex:number[];
let tid:NodeJS.Timeout;
let happyGirls:Girl[];
let isEnd = false;

const Board = (props:Props)=> {
    Ajax.setUserId(props.userId);
    const [isToast,setIsToast] = useState(false);
    const defGirls:Girl[] = [];
    const [states,setStates] = useState({
        girls:defGirls,
        lost:"",
        modalPage:"",
        isModal:false,
        alertPage:"",
        isAlert:false,
        turn:0,
        play:Inc.defaultPlay(),
        confirmIndex:0,
    })
    const classes = Styles.base();

    const handleModalClose = ()=>{
        if( states.modalPage==="confirm" ){
            closeConfirm();
        } else if( states.modalPage==="result" ){
            setStates({...states,"isModal":false});
            props.move("top");
        } else {
            setStates({...states,"isModal":false});
        }
    };
    
    const handleAlertClose = ()=>{
        if( isEnd ){
            //props.move("top");
            Ajax.send("play/close",{gid:states.play.gid,turn:states.turn},(res:any)=>{
                if( res.ok ){
                    //rcp.history.push("/"+states.play.gid);
                    let play = states.play;
                    play.turn = states.turn;
                    isEnd = false;
                    setStates({...states,"play":play,"modalPage":"result","isModal":true})
                }
            });
        } else {
            setStates({...states,"alertPage":"","isAlert":false});
            //setStates({...states,"isAlert":false});
        }
    };

    const handleToastClose = ()=>{
        setIsToast(false);
    }

    const closeConfirm = ()=>{       
        let girls = states.girls;

        if( unlockedIndex.includes(states.confirmIndex) || !girls[states.confirmIndex].sleep ){
            setStates({...states,"isModal":false});
            return;
        }

        unlockedIndex.push(states.confirmIndex);
        girls = openGirl(girls,states.confirmIndex);
        setStates({...states,"girls":girls,"isModal":false});

        let clearFlag = false;
        let happyFlag = false;
        if( unlockedIndex.length===2 ){
            if( girls[unlockedIndex[0]].lover===unlockedIndex[1] && girls[unlockedIndex[1]].lover===unlockedIndex[0] ){
                happyFlag = true;
            } else if( girls[unlockedIndex[0]].lover!==unlockedIndex[1] && girls[unlockedIndex[1]].lover!==unlockedIndex[0] ){
                clearFlag = true;
            } else {
                setIsToast(true);
            }
        }
        if( unlockedIndex.length===3 ){
            if( unlockedIndex.includes(girls[unlockedIndex[0]].lover) && unlockedIndex.includes(girls[unlockedIndex[1]].lover) && unlockedIndex.includes(girls[unlockedIndex[2]].lover) ){
                happyFlag = true;
            } else {
                clearFlag = true;
            }
        }
        
        if( clearFlag ){
            isWaiting = true;
            tid = setTimeout(()=>{
                unlockedIndex = [];
                isWaiting = false;
                clearUnlock();
            },500);    
        }
        if( happyFlag ){
            unlockedIndex = [];
            wakeup();
        }
    }

    const clearUnlock = ()=>{
        let girls = states.girls;
        for( let i=0 ; i<girls.length ; i++ ){
            if( !girls[i].locked && girls[i].sleep ){
                girls[i].locked = true;
            }
        }
        setStates({...states,"girls":girls,"turn":states.turn+1,"isModal":false});
    }

    const wakeup = ()=>{
        let girls = states.girls;
        let num = 0;
        happyGirls = [];
        for( let i=0 ; i<girls.length ; i++ ){
            if( !girls[i].locked && !girls[i].sleep ){
                num++;
            }
            if( !girls[i].locked && girls[i].sleep ){
                girls[i].sleep = false;
                happyGirls.push( girls[i] );
                num++;
            }
        }
        if( num===23 ){
            isEnd = true;
        }
        setStates({...states,"girls":girls,"turn":states.turn+1,"isModal":false,"alertPage":"happy","isAlert":true});
    }

    const confirm = (index:number)=>{
        if( isWaiting ){
            return;
        }
        setStates({...states,"isModal":true,"modalPage":"confirm","confirmIndex":index});
    }

    const openGirl = (girls:Girl[],pos:number)=>{
        if(!girls[pos].sleep){
            return girls;
        }
        girls[pos].locked = false;
        girls[pos].sleep = true;
        return girls;
    }

    useEffect( ()=>{
        unlockedIndex = [];
        isEnd = false;
        happyGirls = [];
        isWaiting = false;
        Ajax.send("play/new",{},(res:any)=>{
            //console.log(res);
            isLoading = false;
            if( res.ok ){
                setStates({...states,"play":res.play,"girls":res.girls,"lost":res.lost,"turn":1,"isAlert":true,"alertPage":"first"});
            }
        });
        return ()=>{
            if( tid ){
                clearTimeout(tid);
            }
        }
    },[]);

    return (
		<div id="board" className={classes.mainRoot}>
            <div className={classes.cemetery}>
                <Grid container spacing={0}>
                    {states.girls.map( (girl:Girl,index:number)=>{
                        const key="girl"+index;
                        let lover = states.girls[ girl.lover ].name;
                        if(girl.lover===index){
                            lover = states.lost;
                        }
                        let boxclass = classes.lockedBox;
                        if( !girl.locked ){
                            boxclass = classes.openBox;
                        }
                        return (
                            <Grid item xs={2} key={key}>
                                <div className={boxclass} onClick={()=>confirm(index)}>
                                {girl.locked && girl.sleep &&
                                    <LockIcon className={classes.lockedIcon}/>
                                }
                                {!girl.locked && !girl.sleep &&
                                <React.Fragment>
                                    <div className={classes.tate}>
                                        {girl.name}
                                    </div>
                                    <div className={classes.boxHeart}><FavoriteIcon/></div>
                                </React.Fragment>
                                }
                                {!girl.locked && girl.sleep &&
                                <React.Fragment>
                                    <div className={classes.tate}>
                                        {girl.name}
                                    </div>
                                    <div className={classes.boxValue}><FavoriteIcon style={{fontSize:"80%"}}/>{lover}</div>
                                </React.Fragment>
                                }
                                </div>
                            </Grid>
                        );
                    })}
                </Grid>
            </div>
            <div className={classes.turn}>
                {states.turn} 時限
            </div>
            <Loading isLoading={isLoading}/>
            <Success variant="success" open={isToast} close={handleToastClose}/>
            <Modal
				aria-labelledby="simple-modal-title"
				aria-describedby="simple-modal-description"
				open={states.isModal}
				onClose={handleModalClose}
			>
				<div style={Tools.getModalStyle()} className={classes.modal}>
                {states.modalPage==="confirm" &&
                    <Confirm girls={states.girls} index={states.confirmIndex} unlockedIndex={unlockedIndex} lost={states.lost} close={handleModalClose}/>
                }
                {states.modalPage==="result" &&
                    <Result play={states.play} close={handleModalClose}/>
                }
	    		</div>
			</Modal>
            <Modal
				aria-labelledby="simple-modal-title"
				aria-describedby="simple-modal-description"
				open={states.isAlert}
				onClose={handleAlertClose}
			>
				<div style={Tools.getModalStyle()} className={classes.alert}>
                {states.alertPage==="first" &&
                    <First play={states.play} close={handleAlertClose}/>
                }
                {states.alertPage==="happy" &&
                    <Happy girls={happyGirls} isEnd={isEnd} close={handleAlertClose}/>
                }
	    		</div>
			</Modal>

		</div>
	);
}

export default Board;
